export default {
  computed: {
    leipzigUniversityLink () {
      switch (this.currentLocale) {
        case 'de':
          return 'https://www.uni-leipzig.de'
        default:
          return 'https://www.uni-leipzig.de/en'
      }
    },
    imprintLink () {
      switch (this.currentLocale) {
        case 'de':
          return 'https://www.uni-leipzig.de/impressum'
        default:
          return 'https://www.uni-leipzig.de/en/legal-notice'
      }
    },
    privacyPolicyLink () {
      switch (this.currentLocale) {
        case 'de':
          return 'https://www.uni-leipzig.de/datenschutz'
        default:
          return 'https://www.uni-leipzig.de/en/privacy'
      }
    },
    portalEditLink () {
      return `/fob/bearbeiten/${this.resourceType}/${this.internalId || this.resourceId}`
    },
    sdgPortalLink () {
      switch (this.currentLocale) {
        case 'de':
          return 'https://sdg-portal.de/de/ueber-das-projekt/17-ziele'
        default:
          return 'https://sdgs.un.org/goals'
      }
    },
  },
  methods: {
    wikiLink (id, anchor) {
      let url = `${process.env.LEURIS_WIKI_URL}?id=${id}`
      if (anchor) {
        url += '#' + anchor
      }
      return url
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/mixins/ExternalLinkProvider.js